export default __webpack_public_path__ + "static/media/logo_edr.28274f4a.svg";